"use client";

import { customSanitize } from "@/utils/customSanitize";
import { HeadlineTagType } from "./Headline";
import { useSearchParams } from "next/navigation";

type SublineProps = {
  subline?: string;
  headline_html_tag: HeadlineTagType;
  isQuote: boolean;
};

export const SublineKeywordWrapper = ({
  subline: sublineProps,
  ...props
}: SublineProps) => {
  const searchParams = useSearchParams();
  const keyword = searchParams?.get("keyword");

  const subline = keyword ?? sublineProps;

  return <Subline subline={subline} {...props} />;
};

export const Subline = ({
  subline,
  headline_html_tag,
  isQuote,
}: SublineProps) => {
  return (
    subline && (
      <span
        //needs both classes to work ( global and specific class)
        className={`subline subline-${headline_html_tag} ${isQuote ? "quotes-banner-subline" : ""}`}
        dangerouslySetInnerHTML={{ __html: customSanitize(subline) }}
      ></span>
    )
  );
};
